<template>
  <svg 
    viewBox="0 0 24 24" 
    fill="currentColor" 
    width="24" 
    height="24"
    aria-hidden="true"
  >
    <path 
      fill-rule="evenodd" 
      d="M12 2.25c-5.385 0-9.75 4.365-9.75 9.75s4.365 9.75 9.75 9.75 9.75-4.365 9.75-9.75S17.385 2.25 12 2.25zM8.47 8.47a.75.75 0 011.06 0L12 10.94l2.47-2.47a.75.75 0 111.06 1.06L13.06 12l2.47 2.47a.75.75 0 11-1.06 1.06L12 13.06l-2.47 2.47a.75.75 0 01-1.06-1.06L10.94 12 8.47 9.53a.75.75 0 010-1.06z" 
      clip-rule="evenodd" 
    />
  </svg>
</template>

<script setup lang="ts">
// Error icon - circle with X
</script>
